export default "__VITE_ASSET__BPgR$FLU__"